/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DockerSettingsSchema
 */
export interface DockerSettingsSchema {
    /**
     * 
     * @type {boolean}
     * @memberof DockerSettingsSchema
     */
    useDockerHub: boolean;
    /**
     * 
     * @type {string}
     * @memberof DockerSettingsSchema
     */
    uri?: string;
    /**
     * 
     * @type {string}
     * @memberof DockerSettingsSchema
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof DockerSettingsSchema
     */
    password: string;
}

/**
 * Check if a given object implements the DockerSettingsSchema interface.
 */
export function instanceOfDockerSettingsSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "useDockerHub" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function DockerSettingsSchemaFromJSON(json: any): DockerSettingsSchema {
    return DockerSettingsSchemaFromJSONTyped(json, false);
}

export function DockerSettingsSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerSettingsSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'useDockerHub': json['use_docker_hub'],
        'uri': !exists(json, 'uri') ? undefined : json['uri'],
        'username': json['username'],
        'password': json['password'],
    };
}

export function DockerSettingsSchemaToJSON(value?: DockerSettingsSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'use_docker_hub': value.useDockerHub,
        'uri': value.uri,
        'username': value.username,
        'password': value.password,
    };
}

